import { ResponseError, ResponseRetry } from './types'
import TreeNode from './tree'

export function isResponseError(
  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  response: unknown | ResponseError
): response is ResponseError {
  return (
    typeof response === 'object' &&
    response !== null &&
    'body' in response &&
    'status' in response &&
    'ok' in response &&
    'statusText' in response &&
    response.ok === false
  )
}

export function isResponseRetry(
  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  response: unknown | ResponseError | ResponseRetry
): response is ResponseRetry {
  if (typeof response !== 'object' || !response) {
    return false
  }

  if (isResponseError(response) && typeof response.body === 'object') {
    return !!response.body?.retriable
  }

  if (typeof response === 'object' && 'retriable' in response) {
    return !!response.retriable
  }

  return false
}

export function isNotEmptyTree<T>(
  treeNode: TreeNode<T | null>
): treeNode is TreeNode<T> {
  return !treeNode.isEmpty()
}
